"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withModules = exports.createModulesProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const utils_1 = require("../utils");
/**
 * Creates ModulesProvider and useModules hook for requested modules
 *
 * @param modules — modules to provide
 */
function createModulesProvider(...modules) {
    const ModulesContext = (0, react_1.createContext)({});
    /**
     * ModulesProvider provides requested modules instances from DI container
     *
     * @param children — children tree
     * @param provide — array of modules' classes to provide
     */
    function ModulesProvider({ children }) {
        const exportedModules = (0, utils_1.getModules)(...modules);
        return ((0, jsx_runtime_1.jsx)(ModulesContext.Provider, { value: exportedModules, children: children }));
    }
    /**
     * Hook to access modules provided by ModulesProvider
     */
    function useModules() {
        return (0, react_1.useContext)(ModulesContext);
    }
    return {
        ModulesProvider,
        useModules,
    };
}
exports.createModulesProvider = createModulesProvider;
const withModules = (...modules) => {
    const { ModulesProvider, useModules } = createModulesProvider(...modules);
    return (WrappedComponent) => {
        const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const WithModules = (props) => {
            const wrappedProps = Object.assign(Object.assign({}, props), { useModules });
            return ((0, jsx_runtime_1.jsx)(ModulesProvider, { "data-e2e": 'ModulesProvider', children: (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, wrappedProps, { "data-e2e": 'WrappedComponent' })) }));
        };
        WithModules.displayName = displayName;
        return WithModules;
    };
};
exports.withModules = withModules;
